<p-card
  [title]="carouselComponentContentBanner().content.headline"
  class="flex carousel-presentation"
  styleClass="noBorder"
  [class.card-max-width]="!isResponsive()">
  <div>
    @if (carouselComponentContentBanner().content.image) {
      <ppg-image
        [url]="carouselImgUrl()"
        [imageStyle]="{
          'object-fit': 'cover',
          'aspect-ratio': '6 / 5',
        }"
        [height]="carouselImgHeight()"
        [width]="carouselImgWidth()"
        [description]="carouselImgDescription()"
        class="w-full" />
    }
    <div class="vertical-content-banner-body">
      @if (carouselComponentContentBanner().content.showLogo) {
        <div class="logo">
          <img [ngSrc]="logo()" alt="PPG Logo" width="58" height="46" />
        </div>
      }
      <ppg-content-banner-headline
        [headline]="carouselComponentContentBanner().content.headline"></ppg-content-banner-headline>
      <ppg-content-banner-subheading
        [subheading]="carouselComponentContentBanner().content.subheading"></ppg-content-banner-subheading>
      <div>
        @for (contentItem of carouselComponentContentBanner().content.content; track $index) {
          <ppg-rich-text class="description" [content]="contentItem.content"></ppg-rich-text>
        }
      </div>
      @if (carouselPresentationContentBannerCta()) {
        <ppg-container-content-banner-cta [cta]="carouselPresentationContentBannerCta()" />
      }
    </div>
  </div>
</p-card>
